import React, { useState } from "react";
import DataTable from "react-data-table-component";
import DatatableStyles from 'component/utils/DatatableStyles';
import { formatRupiah } from "component/utils/formatRupiah";


const paginationOptions = {
    rowsPerPageText: "Show Per Page:", 
    rangeSeparatorText: "dari",
  };

const ItemDatatables = ({data, onShowImage, onEditItem, onDeleteItem, onAddFeature, onAddPrice}) => {
    const [search, setSearch] = useState("");

    const formattedData = data.map((item, index) => ({
      id: index + 1,
      ...item
    }));

    const filteredData = formattedData.filter((item) =>
      [item?.title, item?.price, item?.country]
        .some((field) => field?.toString().toLowerCase().includes(search.toLowerCase()))
    );

    
    const columns = [
      { name: "No", selector: (row) => row.id, width: "70px",style: { display: "flex", justifyContent: "center", alignItems: "center" }, sortable: true },
      { name: "Title", selector: (row) => row.title, sortable: true, minWidth: "100px", maxWidth: "400px"},
      { name: "Price", selector: (row) => formatRupiah(row.price), sortable: true, minWidth: "100px", maxWidth: "400px"},
      { name: "Country", selector: (row) => row.country, sortable: true, minWidth: "100px", maxWidth: "150px" },
      { name: "City", selector: (row) => row.city, minWidth: "100px", maxWidth: "150px" },
      { 
        name: "Action", 
        minWidth: "100px", 
        maxWidth: "300px",
        style: { display: "flex", justifyContent: "center", alignItems: "center" },
        cell: (row) => (
          <div>
              <button 
                class="btn btn-sm rounded-circle btn-primary m-1" // Tambahkan margin agar tidak berdempetan
                onClick={() => onShowImage(row)}
              >
                <i class='bx bx-image' style={{color:"white"}}></i>
              </button>

              <button 
                class="btn btn-sm rounded-circle btn-warning m-1" // Tambahkan margin agar tidak berdempetan
                onClick={() => onEditItem(row)}
              >
                <i class='bx bx-edit' style={{color:"white"}}></i>
              </button>

              <button 
                class="btn btn-sm rounded-circle btn-danger m-1"
                onClick={() => onDeleteItem(row)}
              >
                <i class='bx bx-trash'></i>
              </button>

              <button 
                class="btn btn-sm rounded-circle btn-success m-1"
                onClick={() => onAddFeature(row)}
              >
                <i class='bx bx-list-check'></i>
              </button>

              <button
                className="btn btn-sm rounded-circle btn-info m-1"
                onClick={() => onAddPrice(row)}
              >
                <i className="bx bx-money"></i>
              </button>
            </div>
        )
      }
    ];

  return (
    <div class="col-lg-12 mb-4">
        <div class="d-flex justify-content-start align-items-center mb-2">
                <input
                type="text"
                placeholder="Search..."
                class="form-control w-100"
                style={{ maxWidth: "200px" }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                />
        </div>

        <div class="datatable-container">
            <DataTable
            columns={columns}
            data={filteredData}
            pagination
            highlightOnHover={false}
            customStyles={DatatableStyles}
            paginationPerPage={5}
            paginationRowsPerPageOptions={[5, 10, 25]}
            paginationComponentOptions={paginationOptions}
            responsive
            />
        </div>
    </div>
  );
};

export default ItemDatatables;
